import { Save } from "lucide-react";
import { L, cls, DAYS_1_31 } from "./cardUtils";

// Kayıtlı kart tanım formu (firma/banka/kart no/kesim-ödeme günü)
export default function RegCardForm({ regForm, setRegForm, companyOptions, bankOptions, onSubmit, onCancel }) {
  const set = (k) => (e) => setRegForm({ ...regForm, [k]: e.target.value });
  return (
    <form onSubmit={onSubmit} className="p-4 grid grid-cols-2 md:grid-cols-4 gap-3 border-b border-slate-200 bg-amber-50/40" data-testid="regcard-form">
      <L label="Firma">
        <select required data-testid="regcard-field-company" value={regForm.company} onChange={set("company")} className={cls}>
          <option value="">Seçiniz…</option>
          {companyOptions.map((n) => <option key={n} value={n}>{n}</option>)}
        </select>
      </L>
      <L label="Banka">
        <select required data-testid="regcard-field-bank" value={regForm.bank} onChange={set("bank")} className={cls}>
          <option value="">Seçiniz…</option>
          {bankOptions.map((n) => <option key={n} value={n}>{n}</option>)}
        </select>
      </L>
      <L label="Kart No"><input required data-testid="regcard-field-no" value={regForm.card_no} onChange={set("card_no")} className={cls} placeholder="örn. …4521" /></L>
      <L label="İsim Soyisim"><input data-testid="regcard-field-holder" value={regForm.holder_name} onChange={set("holder_name")} className={cls} placeholder="kart üzerindeki isim" /></L>
      <L label="Son Kullanma Tarihi"><input type="month" data-testid="regcard-field-expiry" value={regForm.expiry_date} onChange={set("expiry_date")} className={cls} /></L>
      <L label="Hesap Kesim Günü">
        <select data-testid="regcard-field-statement" value={regForm.statement_day} onChange={set("statement_day")} className={cls}>
          <option value="">Gün seçin…</option>
          {DAYS_1_31.map((d) => <option key={d} value={d}>{d}. Gün</option>)}
        </select>
      </L>
      <L label="Son Ödeme Günü">
        <select data-testid="regcard-field-due" value={regForm.due_day} onChange={set("due_day")} className={cls}>
          <option value="">Gün seçin…</option>
          {DAYS_1_31.map((d) => <option key={d} value={d}>{d}. Gün</option>)}
        </select>
      </L>
      <div className="flex items-end justify-end gap-2">
        <button type="button" onClick={onCancel} data-testid="regcard-cancel" className="px-3 py-2 text-xs text-slate-600 hover:text-slate-900">İptal</button>
        <button type="submit" data-testid="regcard-save" className="inline-flex items-center gap-1.5 px-3 py-2 rounded-md bg-slate-900 text-white text-xs font-semibold hover:bg-slate-800"><Save className="w-3.5 h-3.5" /> Kaydet</button>
      </div>
    </form>
  );
}
